import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </C>
  );
};

const LINE = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, delay: d, ease: EASE } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, onView = false }) => {
  const anim = onView
    ? { whileInView: "show", viewport: { once: true, amount: 0 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...anim}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClassName}`} variants={LINE} custom={delay + i * 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const ClipImage = ({ src, alt, className = "", imgClassName = "" }) => (
  <motion.div className={className} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0 }}>
    <motion.div
      className="relative h-full w-full overflow-hidden rounded-[inherit]"
      variants={{ hidden: { clipPath: "inset(12% 12% 12% 12%)" }, show: { clipPath: "inset(0% 0% 0% 0%)", transition: { duration: 1.3, ease: EASE } } }}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full object-cover ${imgClassName}`}
        variants={{ hidden: { scale: 1.18 }, show: { scale: 1, transition: { duration: 1.6, ease: EASE } } }}
      />
    </motion.div>
  </motion.div>
);
